

















import { Component, Prop, Vue } from 'vue-property-decorator'
import AchievementRow from './AchievementRow.vue'

@Component({
  components: {
    AchievementRow
  }
})
export default class AchievementBox extends Vue {
  @Prop() private stats!: Record<string, number>;

  get achievements () {
    return [{
      name: 'Possibilities Eliminated',
      amts: [1, 100, 10000, 100000, 1000000, 100000000],
      key: 'possibilitiesEliminated'
    }, {
      name: 'Cells Solved',
      amts: [1, 5, 20, 50, 100, 500, 1000],
      key: 'cellsSolved'
    }, {
      name: 'Completed Puzzles',
      amts: [1, 5, 10, 25, 50, 100, 1000, 10000],
      key: 'puzzlesSolved'
    }, {
      name: 'Puzzles Failed',
      amts: [1, 10, 20, 500, 1000, 5000, 10000, 100000],
      key: 'puzzlesFailed'
    }]
  }
}
